<template lang="html">
    <div class="login">
        <div class="container">
            <div class="content">
                <p>全医佳</p>
                <p>为医院设备管理量身定做管理系统</p>
                <div class="wx">
                    <!-- <img src="https://static.qyjmed.com/webSite/index/wx.png" alt=""> -->
                    <div id="qrcode">
                    </div>
                </div>
                <img v-if="!isScan" src="https://static.qyjmed.com/webSite/index/login/loginpage_write_scan@3x.png" alt="">
                <img v-else src="https://static.qyjmed.com/webSite/index/login/login-success.png" alt="">
            </div>
        </div>
        <dialog-bar v-model="isShow" type="danger" title="提示" content="是否登录？" ></dialog-bar>
    </div>
</template>

<script>
import axios from 'axios'
// websocket连接
import SockJS from  'sockjs-client';
import  Stomp from 'stompjs';
// 生成二维码
import QRCode from 'qrcodejs2';
// 弹出框
import dialogBar from '@/components/dialog.vue'
export default {
    data(){
        return {
            stompClient:'',
            timer:'',
            codes:'',
            message:'',
            isShow:false,
            isScan:false,
            name:'1'
        }
    },
    methods:{
        initWebSocket() {
            this.connection();
            let that= this;
            // 断开重连机制,尝试发送消息,捕获异常发生时重连
            // this.timer = setInterval(() => {
            //     try {
            //         that.stompClient.send("test");
            //     } catch (err) {
            //         console.log("断线了: " + err);
            //         that.connection();
            //     }
            // }, 5000);
        },
        connection() {
            // 建立连接对象
            let socket = new SockJS(this.$store.state.url+'/sws');
            // 获取STOMP子协议的客户端对象
            let stompClient = Stomp.over(socket);
            // 定义客户端的认证信息,按需求配置
            let headers = {
                Authorization:''
            }
            let that =this
            // 向服务器发起websocket连接
            stompClient.connect(headers,() => {
                 stompClient.subscribe('/user/queue/confirm', (msg) => {
                    // console.log('扫码回调');
                    // this.isScan=true
                },headers);
                stompClient.subscribe('/user/queue/snCode', (msg) => {
                    // console.log('回调代表授权成功');
                    // this.$router.push({path:'/'})
                },headers);
                // 获取码
                stompClient.subscribe('/user/queue/one', (msg) => { // 订阅服务端提供的某个topic
                    if(msg.headers.destination == "/user/queue/one"){
                        let qrcode = new QRCode('qrcode', {
                          width: 140,
                          height: 140,
                          text: msg.body, // 二维码地址
                          colorDark : "#000",
                          colorLight : "#fff",
                        })
                        this.message=msg.body
                    }else if(msg.headers.destination == "/user/queue/confirm"){
                        console.log('扫码回调');
                        this.isScan=true
                    }else if(msg.headers.destination == "/user/queue/snCode"){
                        console.log('回调代表授权成功');
                        that.$store.state.login = 'login';
                        let baseUrl= window.sessionStorage.getItem("url") || '/';
                        that.$nextTick(() => {
                            setTimeout(function(){
                                that.$router.push({path: baseUrl})
                            },1000)
                        })


                    }
                },headers);
                stompClient.send("/app/one",
                    headers,
                    JSON.stringify({sender: '',chatType: 'JOIN'}),
                )   //用户加入接口
            }, (err) => {
                // 连接发生错误时的处理函数
                console.log('失败')
                console.log(err);
            });
        },    //连接 后台
        disconnect() {
            if (this.stompClient) {
                this.stompClient.disconnect();
            }
        },  // 断开连接
    },
    mounted(){
        this.initWebSocket();
    },
    components:{
        'dialog-bar': dialogBar,
    },
    beforeDestroy: function () {
        // 页面离开时断开连接,清除定时器
        this.disconnect();
        clearInterval(this.timer);
    }
}
</script>

<style lang="scss" scoped>
    @media only screen and (max-height: 800px){
        div.login div.container .content{
            margin-top: 14%;
            p{
                margin-bottom: 30px;
            }
            div{
                margin:60px auto 30px;
            }
        }
    }
    #qrcode{
        padding:10px;
        margin:10px;
        display: inline-block;
        background: white;
    }
    .login{
        background: url('https://static.qyjmed.com/webSite/index/login/login3x.png') center no-repeat;
        height: 100vh;
        width: 100vw;
        margin-top: $highlight-height;
        position: absolute;
        background-size: 100%;
        // img{
        //     position: relative;
        //     top: 492px;
        //     left: 1120px;
        // }
        .container{
            .content{
                color: white;
                width: 600px;
                margin-left: 600px;
                margin-top: 18%;
                font-size: 34px;
                text-align: center;
                p{
                    margin-bottom: 40px;
                    letter-spacing: 2px;
                }
                >div{
                    background: url('https://static.qyjmed.com/webSite/index/login/loginpage_scan_box@2x.png');
                    height: 180px;
                    width: 180px;
                    margin:100px auto 60px;
                    img{
                        width: 90%;
                        margin-top: 5%;
                    }
                }
            }
        }
    }
</style>
